import type { TooltipProps } from 'recharts';
import { baseWhite } from '../../../../../../styles/design-tokens';
import { isTransitionalTooltip } from './initiative-progress-chart.helpers';
import { DataKey } from './initiative-progress-chart.type';

export const InitiativeProgressChartTooltip = (props: TooltipProps<number, string>) => {
  const { active, payload, label } = props as any;
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const isTransitional = isTransitionalTooltip(payload);

  const formattedPayload = isTransitional
    ? payload.filter((entry: any) =>
        [DataKey.CompletedRegular, DataKey.TotalRegular].includes(entry.dataKey as DataKey),
      )
    : payload;

  return (
    <div
      style={{
        backgroundColor: baseWhite,
        padding: '8px 12px',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      }}
    >
      <p style={{ margin: '0 0 5px', fontWeight: 'bold' }}>{label}</p>
      {formattedPayload.map((entry: any, index: any) => (
        <p key={`item-${index}`} style={{ margin: '0', color: entry.color }}>
          {entry.name}: {entry.value}
        </p>
      ))}
    </div>
  );
};
